import React from 'react';
import InputCtrl from '../../../../components/UI/Input/input-ctrl';
import { EMAIL, PROFILE } from '../../../../shared/AppImages';
import { validateRentalInformationFields } from '../../helper/common-res-helper';

function ExtendRentalCtrls(props) {
    const { formValue, onChange, disabled } = props;
    return (
        <>
            <InputCtrl
                name="firstName"
                value={formValue?.firstName}
                type="text"
                placeholder="First Name"
                onChange={onChange}
                disabled={disabled || false}
                imgIco={PROFILE}
                isRequired={true}
                validateFunction={validateRentalInformationFields}
            />
            <InputCtrl
                name="lastName"
                value={formValue?.lastName}
                type="text"
                placeholder="Last Name"
                onChange={onChange}
                disabled={disabled || false}
                imgIco={PROFILE}
                isRequired={true}
                validateFunction={validateRentalInformationFields}
            />
            <InputCtrl
                name="email"
                value={formValue?.email}
                type="email"
                placeholder="Email"
                onChange={onChange}
                disabled={disabled || false}
                imgIco={EMAIL}
                isRequired={true}
                validateFunction={validateRentalInformationFields}
            />
            <InputCtrl
                name="rentalAgreementNum"
                value={formValue?.rentalAgreementNum}
                type="text"
                placeholder="RA Number"
                onChange={onChange}
                disabled={disabled || false}
                iconClass="fa fa-car icon"
                isRequired={true}
                validateFunction={validateRentalInformationFields}
            />
        </>
    )
}

export default ExtendRentalCtrls